<template>
  <Base :base-id="'address-popup'" :base-class="'tab-action'">
    <template #header>
      <div class="modal-title">ADDRESS BOOK</div>
    </template>
    <template #body>
      <div v-for="data in modalData?.data" :key="data.ID" class="card">
        <div
          class="cart-info"
          :class="chooseID === data.ID ? 'active' : ''"
          @click="changeData(data)"
        >
          <div class="cart-info-name">{{ data.Name }}</div>
          <div class="cart-info-content">
            <p class="cart-info-phone">{{ data.PhoneCountryCode }} {{ data.PhoneNumber }}</p>
            <p class="cart-info-address">
              {{ data.Country }}
              {{ data.Province }}
              {{ data.City }}
              {{ data.District }}
              {{ data.Address }}
            </p>
            <p>{{ data.CustomsClearanceID }}</p>
            <p>{{ data.Address2 }}</p>
            <p>{{ data.Address3 }}</p>
            <p>{{ data.Zip }}</p>
          </div>
        </div>
        <div class="delete-address">
          <a @click.prevent="deleteAddress(data.ID)">
            <i class="icon-delete" />
          </a>
        </div>
      </div>
    </template>
    <template #footer>
      <a class="btn btn-block btn-primary use-address" @click="use">確定</a>
    </template>
  </Base>
</template>

<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';

import useAlert from '@global/composable/useAlert';
import useModalStore from '@global/stores/useModalStore';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';

import Base from '@global/components/common/modal/Base.vue';

const modalStore = useModalStore();
const { modalData } = storeToRefs(modalStore);
const { deleteAddressBookAPI } = useAxiosAPI();

const chooseData = ref({});
const chooseID = ref('');
const { alertDialog } = useAlert();

function deleteAddress(id) {
  deleteAddressBookAPI(id)
    .then((res) => {
      if (res.data.Code === 200) {
        const findDataIndex = modalData.value.data.findIndex((ele) => ele.ID === id);
        const filterData = modalData.value.data.filter((e) => {
          return id !== e.ID;
        });
        modalData.value = { delete: findDataIndex, data: filterData };
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

function changeData(data) {
  chooseData.value = data;
  chooseID.value = data.ID;
}

function use() {
  if (chooseData.value.Country !== window.shippingRegion) {
    alertDialog.alert('地區與所選擇不同');
    return;
  }
  if (chooseData.value.Province && chooseData.value.Province !== window.shippingProvince) {
    alertDialog.alert('省份與所選擇不同');
    return;
  }
  modalData.value = { useAddress: chooseData.value };
}
</script>
